import { useAuth0 } from '@auth0/auth0-react';
import { Alert, Box, Button, Grid, styled, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';

const TypographyMargin = styled(Typography)(({ theme }) => ({
    margin: '16px',
    textAlign: 'center',
}));

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const InvitationSignup = () => {
    const { isAuthenticated, loginWithRedirect } = useAuth0();

    const [redirectToHome, setRedirectToHome] = useState(false);

    let query = useQuery();
    let userType = query.get('type');
    let userCode = query.get('code');
    let expiryDate = query.get('expiry');
    let schoolName = query.get('school');

    useEffect(() => {
        if (isAuthenticated) {
            setRedirectToHome(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {redirectToHome ? (
                <Redirect to="Home"></Redirect>
            ) : (
                <Box
                    sx={{
                        margin: '20px',
                        textAlign: 'center',
                    }}
                >
                    <TypographyMargin variant="h1">
                        Welcome to airTeachr
                    </TypographyMargin>
                    <TypographyMargin variant="h5">
                        You've arrived here because a school wants you to sign
                        up to use airTeachr
                    </TypographyMargin>
                    <TypographyMargin variant="body">
                        airTeachr is a platform that allows Casual Relief
                        Teachers and Schools to connect. This is a platform for
                        everyone in the school to sign up to, allowing direct
                        communication between the Casual Relief Teacher and
                        their replacement. It also allows School Admin to issue
                        the request to book a Casual Relief Teacher when they
                        are available.
                    </TypographyMargin>

                    <Grid container>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '20px 0px',
                            }}
                        >
                            <Box
                                sx={{
                                    boxShadow: '2px 2px 15px 0 #b3bac7',
                                    padding: '20px',
                                    maxWidth: '300px',
                                    borderRadius: '10px',
                                    backgroundColor: '#FFF',
                                    textAlign: 'center',
                                }}
                            >
                                <Typography
                                    variant="h1"
                                    sx={{
                                        height: '64px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    {userType === 'teacher'
                                        ? 'Teacher'
                                        : 'School'}
                                </Typography>
                                <Typography
                                    data-cy="sign-up-as"
                                    variant="h5"
                                    sx={{
                                        height: '64px',
                                        marginBottom: '16px',
                                    }}
                                >
                                    Sign Up as{' '}
                                    {userType === 'teacher'
                                        ? 'a Relief Teacher'
                                        : 'School Staff'}
                                </Typography>
                                <Box sx={{ margin: '16px 0px' }}>
                                    Join the airTeachr platform as{' '}
                                    {userType === 'teacher'
                                        ? 'a Casual Relief Teacher'
                                        : 'part of the School Staff'}
                                </Box>
                                <Box>
                                    {expiryDate !== null &&
                                    expiryDate > Date.now() ? (
                                        <Button
                                            data-cy="sign-up"
                                            variant="outlined"
                                            onClick={() =>
                                                //Storing in appstorage is not necessary since the code is already sent over the net via the link
                                                loginWithRedirect({
                                                    scope: `${
                                                        process.env
                                                            .REACT_APP_scope
                                                    } ${
                                                        userType === 'teacher'
                                                            ? 'teacherProfile'
                                                            : 'schoolProfile'
                                                    }`,
                                                    display: 'popup',
                                                    screen_hint: 'signup',
                                                    redirectUri: `${process.env.REACT_APP_hostUrl}`,
                                                    appState: {
                                                        'type':
                                                            userType ===
                                                            'teacher'
                                                                ? 'teacher'
                                                                : 'school',
                                                        'returnTo': `/home?type=${
                                                            userType ===
                                                            'teacher'
                                                                ? 'teacher'
                                                                : 'school'
                                                        }&code=${userCode}&school=${schoolName}`,
                                                    },
                                                })
                                            }
                                        >
                                            Sign Up
                                        </Button>
                                    ) : (
                                        <Box>
                                            <Alert
                                                severity="error"
                                                sx={{ margin: '16px' }}
                                            >
                                                This link has expired!
                                            </Alert>
                                            <Link to="/signup">
                                                <Button>New Sign Up</Button>
                                            </Link>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </div>
    );
};

export default InvitationSignup;
